"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProApiClient = void 0;
const ApiError_1 = require("./ApiError");
const ProApiObfuscationResult_1 = require("./ProApiObfuscationResult");
const API_URL = 'https://obfuscator.io/api/v1/obfuscate';
const DEFAULT_TIMEOUT = 300000;
class ProApiClient {
    constructor(config) {
        var _a;
        this.config = {
            apiToken: config.apiToken,
            timeout: (_a = config.timeout) !== null && _a !== void 0 ? _a : DEFAULT_TIMEOUT,
            version: config.version
        };
    }
    async obfuscate(sourceCode, options = {}, onProgress) {
        if (!options.vmObfuscation) {
            throw new ApiError_1.ApiError('obfuscatePro method works only with VM obfuscation. Set vmObfuscation: true in options.', 400);
        }
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/x-ndjson',
            'Authorization': `Bearer ${this.config.apiToken}`
        };
        const body = JSON.stringify({
            code: sourceCode,
            options
        });
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), this.config.timeout);
        let url = API_URL;
        if (this.config.version) {
            url = `${API_URL}?version=${encodeURIComponent(this.config.version)}`;
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers,
                body,
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            return this.handleStreamingResponse(response, onProgress);
        }
        catch (error) {
            clearTimeout(timeoutId);
            if (error instanceof Error && error.name === 'AbortError') {
                throw new ApiError_1.ApiError('Request timeout', 408);
            }
            throw error;
        }
    }
    async handleStreamingResponse(response, onProgress) {
        var _a;
        const text = await response.text();
        const lines = text.trim().split('\n');
        const messages = [];
        for (const line of lines) {
            if (!line.trim()) {
                continue;
            }
            try {
                const message = JSON.parse(line);
                messages.push(message);
                if (message.type === 'progress' && message.message && onProgress) {
                    onProgress(message.message);
                }
            }
            catch (_b) {
            }
        }
        const errorMessage = messages.find((m) => m.type === 'error');
        if (errorMessage) {
            throw new ApiError_1.ApiError((_a = errorMessage.message) !== null && _a !== void 0 ? _a : 'Unknown API error', response.status);
        }
        const result = this.reassembleChunkedResponse(messages);
        if (!result.code) {
            throw new ApiError_1.ApiError('No result received from API', 500);
        }
        return new ProApiObfuscationResult_1.ProApiObfuscationResult(result.code, result.sourceMap || '');
    }
    reassembleChunkedResponse(messages) {
        var _a, _b, _c;
        const codeChunks = [];
        const sourceMapChunks = [];
        let result = { code: '', sourceMap: '' };
        for (const msg of messages) {
            switch (msg.type) {
                case 'chunk':
                    if (msg.field === 'code' && msg.data !== undefined && msg.index !== undefined) {
                        codeChunks[msg.index] = msg.data;
                    }
                    else if (msg.field === 'sourceMap' && msg.data !== undefined && msg.index !== undefined) {
                        sourceMapChunks[msg.index] = msg.data;
                    }
                    break;
                case 'chunk_end':
                    result.code = codeChunks.join('');
                    result.sourceMap = (_a = (sourceMapChunks.join('') || msg.sourceMap)) !== null && _a !== void 0 ? _a : '';
                    break;
                case 'result':
                    result = {
                        code: (_b = msg.code) !== null && _b !== void 0 ? _b : '',
                        sourceMap: (_c = msg.sourceMap) !== null && _c !== void 0 ? _c : ''
                    };
                    break;
            }
        }
        return result;
    }
}
exports.ProApiClient = ProApiClient;
